/* @ts-ignore:next-line */
import Cookies from "js-cookie";

import bus from "../bus";
import { navigateEvents } from "../events";

export default function specialMode(el: HTMLElement, props: { collapsed_only: boolean }) {
  if (el.getAttribute("initialised") === "true") {
    return;
  }
  el.setAttribute("initialised", "true");

  const scrollTarget = document.documentElement;
  const closeButtonElement = el.querySelector(".special-mode__close");

  const observer = new IntersectionObserver(observerTriggered, { threshold: 1 });
  observer.observe(el);

  function observerTriggered(entries: IntersectionObserverEntry[]) {
    if (entries[0].intersectionRatio < 1) {
      collapse();
    }
  }

  function collapse() {
    disconnect();
    el.classList.add("special-mode--collapsed");
  }

  function onCloseButtonClick(e: Event) {
    e.preventDefault();
    collapse();

    // Expires in 30 days
    Cookies.set("special_mode_dismissed", true, { expires: 30 });
  }

  // Collapse immediately if same-origin or special_mode_dismissed cookie set
  const referrer = document.referrer ? new URL(document.referrer) : null;
  const selfReferred = referrer && referrer.origin === window.location.origin;
  const specialModeDismissedCookie = Cookies.get("special_mode_dismissed");

  if (!selfReferred && !specialModeDismissedCookie && !props.collapsed_only) {
    el.classList.remove("special-mode--collapsed");
    connect();
  }

  function connect() {
    closeButtonElement?.addEventListener("click", onCloseButtonClick);
    bus.on(navigateEvents.BEFORE_RENDER, collapse);
  }

  function disconnect() {
    observer.disconnect();
    closeButtonElement?.removeEventListener("click", onCloseButtonClick);
    bus.removeListener(navigateEvents.BEFORE_RENDER, collapse);
  }

  return {
    destroy: disconnect,
  };
}
